module.exports = __webpack_public_path__ + "static/media/correct_icon.be465449.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/correct_icon.png
// module id = 2379
// module chunks = 0